import React from 'react';
import { FileData } from '../../types/training';
import { getIconForFileType } from '../../utils/training';
import './FileItem.css';

interface FileItemProps {
  file: FileData;
  onClick: (event: React.MouseEvent<HTMLDivElement>, file: FileData) => void;
}

const FileItem: React.FC<FileItemProps> = ({ file, onClick }) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    onClick(event, file);
  };

  const formatSize = (bytes?: number): string => {
    if (bytes === undefined) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  return (
    <div
      className="file-item"
      onClick={handleClick}
      title={file.name}
    >
      <div className="file-item-icon">
        {getIconForFileType(file.type, 20)}
      </div>
      <div className="file-item-name">
        <span>{file.name}</span>
      </div>
      <div className="file-item-size">
        {formatSize(file.size)}
      </div>
    </div>
  );
};

export default FileItem;

